export default {
    unsetWebsocket(state){
        state.mySocket.closeWebsocket()
        delete state.mySocket
    },
    addWSEventListener(state, payload){
        let events = []
        if (Array.isArray(payload.eventname)){
            events = payload.eventname
        }else{
            events = [payload.eventname]
        }
        if (!payload.parent){
            console.error(`[addWSEventListener][Failed to Register ${payload.eventname}]`)
            return
        }
        let browserNotifications = {}
        if (payload.browserNotificationPaylod && Object.keys(payload.browserNotificationPaylod) != 0){
            browserNotifications = Object.assign({},payload.browserNotificationPaylod)
        }
        for (const event of events) {
            if (state.useCallbackApproach){
                state.mySocket.addWSEventListener(event, payload.callback, payload.parent, browserNotifications)   
            }else{
                window.addEventListener(event, payload.callback, false)
            }   
        }
    },
    removeWSEventListener(state, payload){
        let events = []
        if (Array.isArray(payload.eventname)){
            events = payload.eventname
        }else{
            events = [payload.eventname]
        }
        for (const event of events) {
            if (state.useCallbackApproach){
                state.mySocket.removeWSEventListener(event, payload.callback, payload.parent)
            }else{
                window.removeEventListener(event, payload.callback, false)
            }
        }
    },

    closeWebsocketConnection(state){
        state.mySocket.closeWebsocket()
    }
};